module.exports = __webpack_public_path__ + "img/my-gift.dd7c7fca.png";